<template>
  <v-card flat color="grey lighten-3">
    <v-card-text>
      <v-data-table
        no-data-text="Nenhum cheque encontrado"
        :items="perfil.cheques"
        :headers="headers"
        hide-default-footer
        :disable-sort="isMobile()"
      >
        <template v-slot:[`item.emissao`]="{ item }">
          {{ formatarData(item.emissao) }}
        </template>
        <template v-slot:[`item.vencimento`]="{ item }">
          {{ formatarData(item.vencimento) }}
        </template>
        <template v-slot:[`item.valor`]="{ item }">
          {{ formatarMoeda(item.valor) }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatMoeda } from "@/global";
import moment from 'moment';

export default {
  props: {
    perfil: Object,
  },
  data: () => ({
    headers: [
      { text: "Filial", value: "descfilial" },
      { text: "Emissão", value: "emissao" },
      { text: "Vencimento", value: "vencimento" },
      { text: "Documento", value: "documento" },
      { text: "Valor", value: "valor" },
    ],
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    formatarMoeda(value) {
      return formatMoeda(value);
    },
    formatarData(value){
        return moment(value).format("DD/MM/YYYY")
    }
  },
};
</script>

<style>
</style>